import { BUSCAR_OPCOES_FILTROS_EMISSOES_CTE } from '../../actions/types'

const initialState = undefined;

const estadoInicial = {
    naturezasOperacoes: [],
    tipoServicoCte: [],
}

export default function reducerBuscarOpcoesFiltrosEmissaoesCte (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case BUSCAR_OPCOES_FILTROS_EMISSOES_CTE: {
      const opcoesFiltros = action.payload.data;

      if (opcoesFiltros) {
        return opcoesFiltros
      }
      return estadoInicial
    }

    // case LIMPAR_OPCOES_FILTROS_EMISSOES_CTE:
    //   return [];

    default: {
      return state
    }
  }
}
